module.exports = __webpack_public_path__ + "img/tab_icon4.a716f30b.png";